import { render, staticRenderFns } from "./RecurringSnapshotVolume.vue?vue&type=template&id=dd63bba0&scoped=true&"
import script from "./RecurringSnapshotVolume.vue?vue&type=script&lang=js&"
export * from "./RecurringSnapshotVolume.vue?vue&type=script&lang=js&"
import style0 from "./RecurringSnapshotVolume.vue?vue&type=style&index=0&id=dd63bba0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd63bba0",
  null
  
)

export default component.exports